import { render } from '@mtfe/sweet';
import { dom, eventBus } from '@mtfe/sweet-utils';
import Index from './pages/index/script';

const { $id } = dom;

render($id('app'), Index, () => {
    eventBus.$emit('ready');
});
